import { Icon } from '@chakra-ui/react';
import { MdDashboard, MdBusiness, MdPeople, MdDataSaverOn, MdAnalytics, MdSupervisorAccount, MdList, MdSchool, MdSettings, MdChecklist, MdGroup, MdCardGiftcard, MdPersonAdd, MdLink } from 'react-icons/md';
import { ModuleDefinition, SidebarLink } from '../types/dashboard';
import { ADMIN_ROUTES, ANALYST_ROUTES, PARTNER_ROUTES, RoleLevel } from '@bemap/utils';

const size = 4;

export const getModuleDefinitions = (t?: (key: string) => string): Record<string, ModuleDefinition> => ({
  admin: {
    id: 'admin',
    label: t ? t('links.modules.administration') : 'Administration',
    href: ADMIN_ROUTES.DASHBOARD,
    homeRoute: ADMIN_ROUTES.DASHBOARD,
    icon: <Icon as={MdDashboard} width={size} height={size} color='inherit' />,
  },
  assessments: {
    id: 'assessments',
    label: t ? t('links.modules.assessments') : 'Assessments',
    href: PARTNER_ROUTES.DASHBOARD,
    homeRoute: PARTNER_ROUTES.DASHBOARD,
    icon: <Icon as={MdAnalytics} width={size} height={size} color='inherit' />,
  },
  crm: {
    id: 'crm',
    label: t ? t('links.modules.crm') : 'CRM',
    href: ADMIN_ROUTES.CRM,
    homeRoute: ADMIN_ROUTES.CRM,
    icon: <Icon as={MdBusiness} width={size} height={size} color='inherit' />,
  },
  university: {
    id: 'university',
    label: t ? t('links.modules.university') : 'University',
    href: ADMIN_ROUTES.UNIVERSITY,
    homeRoute: ADMIN_ROUTES.UNIVERSITY,
    icon: <Icon as={MdPeople} width={size} height={size} color='inherit' />,
  },
});

export const getAdminSidebarLinks = (t?: (key: string) => string): SidebarLink[] => [
  {
    label: t ? t('links.labels.dashboard') : 'Dashboard',
    href: ADMIN_ROUTES.DASHBOARD,
    icon: <Icon as={MdDashboard} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.overview') : 'Overview',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.users') : 'Users',
    href: ADMIN_ROUTES.USERS,
    icon: <Icon as={MdPeople} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.management') : 'Management',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.invoices') : 'Invoices',
    href: ADMIN_ROUTES.INVOICES,
    icon: <Icon as={MdDataSaverOn} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.financial') : 'Financial',
    roles: [RoleLevel.ADMIN],
  },
];

export const getAssessmentsSidebarLinks = (t?: (key: string) => string): SidebarLink[] => [
  {
    label: t ? t('links.labels.dashboard') : 'Dashboard',
    href: PARTNER_ROUTES.DASHBOARD,
    icon: <Icon as={MdDashboard} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.relatorios') : 'Relatórios',
    roles: [RoleLevel.PARTNER, RoleLevel.ANALYST],
  },
  // {
  //   label: 'User Analytics',
  //   href: '/assessments/users',
  //   icon: <Icon as={MdPeople} width={size} height={size} color='inherit' />,
  //   section: 'Reports',
  // },
  // {
  //   label: 'Business Metrics',
  //   href: '/assessments/business',
  //   icon: <Icon as={MdBusiness} width={size} height={size} color='inherit' />,
  //   section: 'Reports',
  // },
  // {
  //   label: 'Financial Reports',
  //   href: '/assessments/financial',
  //   icon: <Icon as={MdDataSaverOn} width={size} height={size} color='inherit' />,
  //   section: 'Reports',
  // },
  {
    label: t ? t('links.labels.partners') : 'Partners',
    href: ADMIN_ROUTES.PARTNERS,
    icon: <Icon as={MdBusiness} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.analysts') : 'Analistas',
    href: PARTNER_ROUTES.ANALYSTS,
    icon: <Icon as={MdSupervisorAccount} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.ADMIN, RoleLevel.PARTNER],
  },
  {
    label: t ? t('links.labels.people') : 'Pessoas',
    href: PARTNER_ROUTES.PEOPLE,
    icon: <Icon as={MdPeople} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.PARTNER],
  },
  {
    label: t ? t('links.labels.certificates') : 'Certificados',
    href: PARTNER_ROUTES.CERTIFICATES,
    icon: <Icon as={MdSchool} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.PARTNER],
  },
  {
    label: t ? t('links.labels.faturas') : 'Faturas',
    href: PARTNER_ROUTES.INVOICES,
    icon: <Icon as={MdCardGiftcard} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.PARTNER],
  },
  {
    label: t ? t('links.labels.integracoes') : 'Integrações',
    href: PARTNER_ROUTES.INTEGRATIONS,
    icon: <Icon as={MdSettings} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.configuracoes') : 'Configurações',
    roles: [RoleLevel.PARTNER],
  },
  {
    label: t ? t('links.labels.palavras') : 'Palavras',
    href: ADMIN_ROUTES.WORDS,
    icon: <Icon as={MdList} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.configuracoes') : 'Configurações',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.creditos') : 'Créditos',
    href: ADMIN_ROUTES.INVOICES,
    icon: <Icon as={MdDataSaverOn} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.financeiro') : 'Financeiro',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.avaliacoes') : 'Avaliações',
    href: ANALYST_ROUTES.ASSESSMENTS,
    icon: <Icon as={MdChecklist} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.perfil_comportamental') : 'Perfil Comportamental',
    roles: [RoleLevel.ANALYST],
  },
  {
    label: t ? t('links.labels.grupos') : 'Grupos',
    href: ANALYST_ROUTES.GROUPS,
    icon: <Icon as={MdGroup} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.perfil_comportamental') : 'Perfil Comportamental',
    roles: [RoleLevel.ANALYST],
  },
  {
    label: t ? t('links.labels.people') : 'Pessoas',
    href: ANALYST_ROUTES.PEOPLE,
    icon: <Icon as={MdPeople} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.ANALYST],
  },
  {
    label: t ? t('links.labels.empresas') : 'Empresas',
    href: ANALYST_ROUTES.COMPANIES,
    icon: <Icon as={MdBusiness} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.ANALYST],
  },
  {
    label: 'Leads',
    href: ANALYST_ROUTES.LEADS,
    icon: <Icon as={MdPersonAdd} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.ANALYST],
  },
  {
    label: t ? t('links.labels.campaign_links') : 'Campaign Links',
    href: ANALYST_ROUTES.CAMPAIGN_LINKS,
    icon: <Icon as={MdLink} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.ANALYST],
  },
];

export const getCrmSidebarLinks = (t?: (key: string) => string): SidebarLink[] => [
  {
    label: t ? t('links.labels.dashboard') : 'Dashboard',
    href: ADMIN_ROUTES.CRM,
    icon: <Icon as={MdDashboard} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.overview') : 'Overview',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.customers') : 'Customers',
    href: ADMIN_ROUTES.CRM,
    icon: <Icon as={MdPeople} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.management') : 'Management',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.sales_pipeline') : 'Sales Pipeline',
    href: ADMIN_ROUTES.CRM,
    icon: <Icon as={MdBusiness} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.sales') : 'Sales',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.reports') : 'Reports',
    href: ADMIN_ROUTES.CRM,
    icon: <Icon as={MdDataSaverOn} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.analytics') : 'Analytics',
    roles: [RoleLevel.ADMIN],
  },
];

export const getUniversitySidebarLinks = (t?: (key: string) => string): SidebarLink[] => [
  {
    label: t ? t('links.labels.inicio') : 'Início',
    href: ADMIN_ROUTES.UNIVERSITY,
    icon: <Icon as={MdDashboard} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.overview') : 'Overview',
    roles: [RoleLevel.ADMIN, RoleLevel.PARTNER, RoleLevel.ANALYST],
  },
  {
    label: t ? t('links.labels.cursos') : 'Cursos',
    href: ADMIN_ROUTES.UNIVERSITY_COURSES,
    icon: <Icon as={MdSchool} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.educacao') : 'Educação',
    roles: [RoleLevel.ADMIN, RoleLevel.PARTNER, RoleLevel.ANALYST],
  },
  {
    label: t ? t('links.labels.alunos') : 'Alunos',
    href: ADMIN_ROUTES.UNIVERSITY_STUDENTS,
    icon: <Icon as={MdPeople} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.certificates') : 'Certificados',
    href: ADMIN_ROUTES.UNIVERSITY_CERTIFICATES,
    icon: <Icon as={MdCardGiftcard} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.gestao') : 'Gestão',
    roles: [RoleLevel.ADMIN],
  },
  {
    label: t ? t('links.labels.certificates') : 'Certificados',
    href: ADMIN_ROUTES.UNIVERSITY_CERTIFICATES,
    icon: <Icon as={MdCardGiftcard} width={size} height={size} color='inherit' />,
    section: t ? t('links.sections.educacao') : 'Educação',
    roles: [RoleLevel.PARTNER, RoleLevel.ANALYST],
  },
];

export const getSubsystemLinks = (t?: (key: string) => string): Record<string, SidebarLink[]> => ({
  admin: getAdminSidebarLinks(t),
  assessments: getAssessmentsSidebarLinks(t),
  crm: getCrmSidebarLinks(t),
  university: getUniversitySidebarLinks(t),
}); 